export default class EmailComponent extends window.HTMLElement {
    constructor () {
        super();

        this.validateEmail = this.validateEmail.bind(this);
        this.removeError = this.removeError.bind(this);
    }

    connectedCallback() {
        this.innerHTML = `
			<span>${this.dataset.errormessage}</span>
			<input type="text" id="${this.getAttribute('inputId')}" name="${this.getAttribute('name')}" aria-required="${this.getAttribute('ariaRequired')}" placeholder="${this.getAttribute('placeholder')}">
		`;

        const emailInput = this.querySelector('input');

        emailInput.addEventListener('blur', (event) => {

            if (!event.target.value) {

                if (this.hasAttribute('allow-empty')) {
                    this.classList.remove('error');
                }

                return;
            }

            this.validateEmail(event.target.value);
        })
    }

    validateEmail(email) {
        try {
            if (email && email != '') {
                let filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let validateEmail = filter.test(email.toLowerCase());
                if (!validateEmail) {
                    this.addError();
                } else {
                    this.removeError();
                }
            } else {
                this.removeError();
            }
        } catch (error) {
            this.addError();
        }
    }

    addError() {
        this.classList.add('error');
    }

    removeError() {
        this.classList.remove('error');
    }
}


// WEBPACK FOOTER //
// ./src/js/components/email.js